type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  icon?: string;
};

export default function SectionHeading({ eyebrow, title, description, icon }: SectionHeadingProps) {
  return (
    <div className="mb-8 md:mb-10">
      <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-700 uppercase">
        {icon && <i className={icon} aria-hidden="true"></i>}
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
        {title}
      </h2>
      {description && (
        <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600">
          {description}
        </p>
      )}
    </div>
  );
}